<!-- 彈窗 編輯附加品項-->
<ng-template #Modal let-data let-ref="dialogRef">

  <form #ModalF="ngForm">
    <nb-card class="staffInfoTemplate"  [nbSpinner]="info.IsLoding">
      <!-- 標題 -->
      <nb-card-header *ngIf="info.moType==1">新增附加品項選項
      </nb-card-header>
      <nb-card-header *ngIf="info.moType==2">
          編輯附加品項選項  
      </nb-card-header>
      <nb-card-header *ngIf="info.moType==4">
          查看附加品項選項
      </nb-card-header>

      <!-- 內容 -->
      <nb-card-body>


        <div class="row rowTop">
          <div class="row mx-0 col-sm-12">
            <label class="label col-sm-12 col-form-label required">選項名稱</label>
            <input name="AttachItemName" nbInput required   autocomplete="off"
             
            [(ngModel)]="att.ItemName">
          </div>

         
        </div>    
        
        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">數量</label>
            <input type="number" name="Quantity" nbInput required   [(ngModel)]="att.Quantity">
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required" >原價</label>
            <input type="number" name="Cash" nbInput min="0"   [(ngModel)]="att.Cash" required>
          </div>
     
        </div>

       
        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">ERP編碼</label>
            <input
            name="SAPProductNo"
            type="text"
            nbInput
            fullWidth
            [(ngModel)]="att.SAPProductNo"
          />
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label" >Barcode</label>
            <input
            name="Barcode"
            type="text"
            nbInput
            fullWidth
            [(ngModel)]="att.Barcode"
          />
          </div>
     
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">外部編碼</label>
            <input
            name="ExternalNo"
            type="text"
            nbInput
            fullWidth
            [(ngModel)]="att.ExternalNo"
          />
          </div>

        </div>
        
        <!-- <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required" >稅別</label>
            <nb-select name="TaxType"    
              [(selected)]="att.TaxType" required>
              <nb-option *ngFor="let tax of TaxTypeList" [value]="tax.value">{{tax.content}}</nb-option>
            </nb-select>
          </div>

          <div class="row mx-0 col-sm-6" *ngIf="att.TaxType == 2">
            <label class="label col-sm-12 col-form-label required" >稅額</label>
            <nb-select name="TaxRate"   
              [(selected)]="att.TaxRate" required disabled>
              <nb-option *ngFor="let tax of TaxRateList" [value]="tax.value">{{tax.content}}</nb-option>
            </nb-select>
          </div>
        </div> -->



        <!-- <div class="row rowTop">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">備註</label>
            <textarea rows="10" name="Note" nbInput min="0" [(ngModel)]="att.Note">
            </textarea>
          </div>
        </div> -->

        <div *ngIf="info.moType==2" class="text-danger mt-3">PS: 修改後會連動到其他使用同選項的群組中，修改前請確認!</div>




      </nb-card-body>

      <!-- 腳 -->
      <nb-card-footer>
        <button *ngIf="this.info.moType != 4"  nbButton (click)="onSave();" [disabled]="ModalF.invalid">確定</button>
        <button nbButton (click)="ref.close()">關閉</button>
      </nb-card-footer>

    </nb-card>
  </form>
</ng-template>